import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, FreeMode } from "swiper/modules";
import { RxArrowLeft, RxArrowRight, RxCross2 } from "react-icons/rx";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import certificate01 from "../assets/Certificates/appreciation-letter.jpg";
import certificate02 from "../assets/Certificates/aarti.jpg";

// Image Data Array
export const ImageData = [
  {
    backgroundImage: certificate01,
  },
  {
    backgroundImage: certificate02,
  },
];

const Certificate = () => {
  const [fullscreenImage, setFullscreenImage] = useState(null);

  // Open image in fullscreen
  const handleImageClick = (image) => {
    setFullscreenImage(image);
  };

  // Close fullscreen
  const handleCloseFullscreen = () => {
    setFullscreenImage(null);
  };

  return (
    <div className="bg-gradient-to-b from-white to-purple-50 py-16 relative">
      {/* Header Section */}
      <div className="text-center mb-12 px-4">
        <h1 className="font-extrabold text-2xl md:text-3xl text-purple-800 mb-2">
          Appreciation Certificate
        </h1>
        <p className="font-medium text-lg md:text-xl text-blue-800">
          We provide high-standard work for your company solutions
        </p>
      </div>

      {/* Swiper Section */}
      <div className="relative max-w-[90%] lg:max-w-[70%] mx-auto">
        {/* Left Navigation Button */}
        <div className="absolute top-1/2 -left-6 transform -translate-y-1/2 z-10">
          <button
            className="bg-purple-600 text-white w-10 h-10 rounded-full flex items-center justify-center shadow-lg hover:bg-purple-500 transition"
            id="swiper-prev"
          >
            <RxArrowLeft size={20} />
          </button>
        </div>

        {/* Right Navigation Button */}
        <div className="absolute top-1/2 -right-6 transform -translate-y-1/2 z-10">
          <button
            className="bg-purple-600 text-white w-10 h-10 rounded-full flex items-center justify-center shadow-lg hover:bg-purple-500 transition"
            id="swiper-next"
          >
            <RxArrowRight size={20} />
          </button>
        </div>

        <Swiper
          breakpoints={{
            // 0: {
            //   slidesPerView: 1,
            //   spaceBetween: 10,
            // },
            // 768: {
            //   slidesPerView: 1,
            //   spaceBetween: 15,
            // },

            0: {
              slidesPerView: 1, // Show 1 image per view on mobile screens
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 2, // Show 2 images per view on larger screens
              spaceBetween: 20,
            },
          }}
          freeMode={true}
          pagination={{ clickable: true }}
          navigation={{
            prevEl: "#swiper-prev",
            nextEl: "#swiper-next",
          }}
          modules={[Navigation, Pagination, FreeMode]}
        >
          {ImageData.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="flex items-center justify-center">
                {/* Image */}
                <img
                  src={item.backgroundImage}
                  alt={`Certificate ${index + 1}`}
                  className="w-full h-[300px] lg:h-[400px]  object-contain rounded-lg shadow-lg cursor-pointer"
                  onClick={() => handleImageClick(item.backgroundImage)}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Fullscreen Image Modal */}
      {fullscreenImage && (
        <div className=" fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
          {/* Close Button */}
          <button
            className="absolute top-8 right-5 text-white bg-red-600 p-2 rounded-full hover:bg-red-500 transition"
            onClick={handleCloseFullscreen}
          >
            <RxCross2 size={30} />
          </button>

          {/* Fullscreen Image */}
          <img
            src={fullscreenImage}
            alt="Fullscreen View"
            className="max-w-[90%] mt-5 max-h-[90%] object-contain rounded-lg"
          />
        </div>
      )}
    </div>
  );
};

export default Certificate;
